export enum LegalDocumentSituationEnum {
  IN_ANALYSIS = "Em análise",
  EXPIRED = "Vencido",
  APPROVED = "Aprovado"
}

export enum LegalDocumentTypeEnum {
  ALVARA = 0,
  CRT = 1,
  OTHER = 2
}